import { create } from "zustand";
import { tradeSupportApi } from "../../services/vendorMaster";
import isEqual from "lodash.isequal";
const GUID = localStorage.getItem("vendorGUID");
const locationCode = localStorage.getItem("locationCode");
const getLastThreeFY = () => {
  const currentYear = new Date().getFullYear();
  return [
    `${currentYear - 3}-${currentYear - 2}`,
    `${currentYear - 2}-${currentYear - 1}`,
    `${currentYear - 1}-${currentYear}`,
  ];
};

const initial = {
  vendorGUID: GUID || "",
  locationCode: "",
  turnoverIncentiveAmount: null,
  turnover: null,
  turnoverRealizationFrequency: null,
  turnoverRealizationMethod: null,
  merchandisingAmountRsPerPerson: null,
  merchandisingNoOfPersonPerStore: null,
  merchandisingOnTurnover: null,
  merchandisingRealizationFrequency: null,
  merchandisingRealizationMethod: null,
  damageStockReturnableByGatePass: null,
  damageStockReplacement: null,
  damageVendorWillTakeBackStocks: null,
  damageNoStockReturnOrReplacementButAllowance: "",
  damageRealizationFrequency: null,
  damageRealizationMethod: null,
  barcodeAmountPerQuantity: "",
  barcodeOnTurnover: "",
  barcodeRealizationFrequency: null,
  barcodeRealizationMethod: null,
  newProductAmount: "",
  newProductOnTurnover: "",
  newProductRealizationFrequency: null,
  newProductRealizationMethod: null,
  storeOpeningAmountSKU: "",
  storeOpeningRealizationFrequency: null,
  storeOpeningRealizationMethod: null,
  storeAnniversaryAmountPerStore: "",
  storeAnniversaryRealizationFrequency: null,
  storeAnniversaryRealizationMethod: null,
  listingFee: "",
  shrinkSharing: null,
  shrinkSharingTurnover: "",
  anyOtherOP1Desc: "",
  anyOtherOP1ConsiderationAmount: "",
  anyOtherOP1RealizationFrequency: null,
  anyOtherOP1RealizationMethod: null,
  anyOtherOP2Desc: "",
  anyOtherOP2ConsiderationAmount: "",
  anyOtherOP2RealizationFrequency: null,
  anyOtherOP2RealizationMethod: null,
  anyOtherOP3Desc: "",
  anyOtherOP3ConsiderationAmount: "",
  anyOtherOP3RealizationFrequency: null,
  anyOtherOP3RealizationMethod: null,
  priceAndMargin: "",
  totAgreement: "",
  // lastThreeYearTurnover: [
  //   {
  //     financialYear: null,
  //     turnoverAmount: "",
  //   },
  // ],
  lastThreeYearTurnover: getLastThreeFY().map((year) => ({
    financialYear: year,
    turnoverAmount: 0,
  })),
};
const mapApiToTradeSupportTerms = (api) => ({
  vendorGUID: api?.VendorGUID ?? GUID,
  locationCode: api?.LocationCode ?? locationCode,
  priceAndMargin: api?.PriceAndMargin,
  totAgreement: api?.TOTAgreement,
  turnoverIncentiveAmount: api?.TurnoverIncentiveAmount ?? null,
  turnover: api?.Turnover ?? null,
  turnoverRealizationFrequency: api?.TurnoverRealizationFrequency ?? null,
  turnoverRealizationMethod: api?.TurnoverRealizationMethod ?? null,

  merchandisingAmountRsPerPerson: api?.MerchandisingAmountRsPerPerson ?? null,
  merchandisingNoOfPersonPerStore: api?.MerchandisingNoOfPersonPerStore ?? null,
  merchandisingOnTurnover: api?.MerchandisingOnTurnover ?? null,
  merchandisingRealizationFrequency:
    api?.MerchandisingRealizationFrequency ?? null,
  merchandisingRealizationMethod: api?.MerchandisingRealizationMethod ?? null,

  damageStockReturnableByGatePass: api?.DamageStockReturnableByGatePass ?? null,
  damageStockReplacement: api?.DamageStockReplacement ?? null,
  damageVendorWillTakeBackStocks: api?.DamageVendorWillTakeBackStocks ?? null,
  damageNoStockReturnOrReplacementButAllowance:
    api?.DamageNoStockReturnOrReplacementButAllowance ?? "",

  damageRealizationFrequency: api?.DamageRealizationFrequency ?? null,
  damageRealizationMethod: api?.DamageRealizationMethod ?? null,

  barcodeAmountPerQuantity: api?.BarcodeAmountPerQuantity ?? "",
  barcodeOnTurnover: api?.BarcodeOnTurnover ?? "",
  barcodeRealizationFrequency: api?.BarcodeRealizationFrequency ?? null,
  barcodeRealizationMethod: api?.BarcodeRealizationMethod ?? null,

  newProductAmount: api?.NewProductAmount ?? "",
  newProductOnTurnover: api?.NewProductOnTurnover ?? "",
  newProductRealizationFrequency: api?.NewProductRealizationFrequency ?? null,
  newProductRealizationMethod: api?.NewProductRealizationMethod ?? null,

  storeOpeningAmountSKU: api?.StoreOpeningAmountSKU ?? "",
  storeOpeningRealizationFrequency:
    api?.StoreOpeningRealizationFrequency ?? null,
  storeOpeningRealizationMethod: api?.StoreOpeningRealizationMethod ?? null,

  storeAnniversaryAmountPerStore: api?.StoreAnniversaryAmountPerStore ?? "",
  storeAnniversaryRealizationFrequency:
    api?.StoreAnniversaryRealizationFrequency ?? null,
  storeAnniversaryRealizationMethod:
    api?.StoreAnniversaryRealizationMethod ?? null,

  listingFee: api?.ListingFee ?? "",
  shrinkSharing: api?.ShrinkSharing ?? null,
  shrinkSharingTurnover: api?.ShrinkSharingTurnover ?? "",

  anyOtherOP1Desc: api?.AnyOtherOP1Desc ?? "",
  anyOtherOP1ConsiderationAmount: api?.AnyOtherOP1ConsiderationAmount ?? "",
  anyOtherOP1RealizationFrequency: api?.AnyOtherOP1RealizationFrequency ?? null,
  anyOtherOP1RealizationMethod: api?.AnyOtherOP1RealizationMethod ?? null,

  anyOtherOP2Desc: api?.AnyOtherOP2Desc ?? "",
  anyOtherOP2ConsiderationAmount: api?.AnyOtherOP2ConsiderationAmount ?? "",
  anyOtherOP2RealizationFrequency: api?.AnyOtherOP2RealizationFrequency ?? null,
  anyOtherOP2RealizationMethod: api?.AnyOtherOP2RealizationMethod ?? null,

  anyOtherOP3Desc: api?.AnyOtherOP3Desc ?? "",
  anyOtherOP3ConsiderationAmount: api?.AnyOtherOP3ConsiderationAmount ?? "",
  anyOtherOP3RealizationFrequency: api?.AnyOtherOP3RealizationFrequency ?? null,
  anyOtherOP3RealizationMethod: api?.AnyOtherOP3RealizationMethod ?? null,
  // lastThreeYearTurnover: api?.LastThreeYearTurnover?.length
  //   ? api.LastThreeYearTurnover.map((item) => ({
  //       financialYear: item.FinancialYear ?? null,
  //       turnoverAmount: item.TurnoverAmount ?? "",
  //     }))
  //   : [
  //       {
  //         financialYear: null,
  //         turnoverAmount: "",
  //       },
  //     ],
  lastThreeYearTurnover:
    api?.LastThreeYearTurnover?.length === 3
      ? api.LastThreeYearTurnover.map((item) => ({
          financialYear: item.FinancialYear ?? null,
          turnoverAmount: item.TurnoverAmount ?? 0,
        }))
      : getLastThreeFY().map((year) => ({
          financialYear: year,
          turnoverAmount: 0,
        })),
});

export const useTradeStore = create((set, get) => ({
  tradeData: {
    ...initial,
  },
  initialTradeData: null,
  errors: null,
  setTradeApi: (api) =>
    set(() => ({
      tradeData: mapApiToTradeSupportTerms(api),
    })),
  handleInputChange: (field, value) =>
    set((state) => {
      let finalValue = value;
      // Fields that should NOT be uppercased
      const noUppercaseFields = [
        "vendorGUID",
        "totAgreement",
        "priceAndMargin",
      ];

      if (typeof value === "string" && !noUppercaseFields.includes(field)) {
        finalValue = value.toUpperCase();
      }
      // if (typeof value === "string") {
      //   if (field !== "vendorGUID") {
      //     finalValue = value.toUpperCase();
      //   }
      // }
      return {
        tradeData: {
          ...state.tradeData,
          [field]: finalValue,
        },
        errors: { ...state.errors, [field]: "" },
      };
    }),

  addTurnoverRow: () => {
    const { lastThreeYearTurnover } = get().tradeData;
    const lastRow = lastThreeYearTurnover[lastThreeYearTurnover.length - 1];

    // if (!lastRow.financialYear || !lastRow.turnoverAmount) {
    //   return false;
    // }
    if (
      !lastRow.financialYear ||
      lastRow.turnoverAmount === "" ||
      lastRow.turnoverAmount === null ||
      lastRow.turnoverAmount === undefined
    ) {
      return false;
    }
    if (lastThreeYearTurnover.length >= 3) {
      return false;
    }

    set((state) => ({
      tradeData: {
        ...state.tradeData,
        lastThreeYearTurnover: [
          ...state.tradeData.lastThreeYearTurnover,
          { financialYear: null, turnoverAmount: "" },
        ],
      },
      errors: { ...state.errors, lastThreeYearTurnover: "" },
    }));

    return true;
  },

  updateTurnoverRow: (index, field, value) =>
    set((state) => ({
      tradeData: {
        ...state.tradeData,
        lastThreeYearTurnover: state.tradeData.lastThreeYearTurnover.map(
          (row, i) => (i === index ? { ...row, [field]: value } : row),
        ),
      },
      errors: { ...state.errors, lastThreeYearTurnover: "" },
    })),

  removeTurnoverRow: (index) =>
    set((state) => ({
      tradeData: {
        ...state.tradeData,
        lastThreeYearTurnover: state.tradeData.lastThreeYearTurnover.filter(
          (_, i) => i !== index,
        ),
      },
      errors: { ...state.errors, lastThreeYearTurnover: "" },
    })),
  validateForm: () => {
    const { tradeData } = get();
    const newErrors = {};

    // Required fields from tradeData
    let requiredFields = {
      turnoverIncentiveAmount: "Turnover Incentive Amount is required",
      damageStockReturnableByGatePass:
        "Damage Stock Returnable by Gate Pass is required",
      damageStockReplacement: "Damage Stock Replacement is required",
      damageNoStockReturnOrReplacementButAllowance:
        "Damage no-return/replacement allowance is required",

      // priceAndMargin: "Price and Margin detail is required",

      // totAgreement: "Tot Agreement is required",

      // newProductAmount: "New Product Amount is required",
      // newProductRealizationFrequency:
      //   "New Product Realization Frequency is required",
      // newProductRealizationMethod: "New Product Realization Method is required",

      // listingFee: "Listing Fee is required",
    };
    // Run validations
    for (const key in requiredFields) {
      const value = tradeData[key];

      // Empty string, null, or undefined should count as missing
      if (value === "" || value === null || value === undefined) {
        newErrors[key] = requiredFields[key];
      }
    }

    const turnover = tradeData.lastThreeYearTurnover;

    if (!Array.isArray(turnover) || turnover.length !== 3) {
      newErrors.lastThreeYearTurnover =
        "Last three year turnover must contain exactly 3 years";
    } else {
      const hasInvalidEntry = turnover.some(
        (item) =>
          !item ||
          !item.financialYear ||
          // !item.turnoverAmount ||
          item.turnoverAmount === "" ||
          item.turnoverAmount === null ||
          item.turnoverAmount === undefined,
      );

      if (hasInvalidEntry) {
        newErrors.lastThreeYearTurnover =
          "All three years must have financial year and turnover amount filled";
      }
    }

    // Save & return
    set({ errors: newErrors });
    return Object.keys(newErrors).length === 0;
  },

  hasTradeChanged: () => {
    const { tradeData, initialTradeData } = get();
    if (!initialTradeData) return true; // first time
    return !isEqual(tradeData, initialTradeData);
  },

  submitTradeSupport: async (form) => {
    const { tradeData } = get();
    set({ loading: true });
    try {
      const response = await tradeSupportApi(tradeData);
      set({
        initialTradeData: JSON.parse(JSON.stringify(tradeData)),
      });
      return response?.Data[0];
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    } finally {
      set({ loading: false });
    }
  },

  // Reset form
  resetForm: () =>
    set({
      tradeData: { ...initial },
      errors: null,
    }),

  deleteTradeFile: (field) =>
    set((state) => ({
      tradeData: {
        ...state.tradeData,
        [field]: "", 
      },
      errors: {
        ...state.errors,
        [field]: "", 
      },
    })),
}));
